import { knowledges } from "../../data";
import "./skills.css";

const Skills = () => {
   return (
      <div className="skills my-5">
         <div className="container">
            <div className="row justify-content-around align-items-center">
               {knowledges.map((item) => (
                  <div key={item.id} className="my-2 my-lg-3 g-5 g-lg-3 col-6 col-sm-4 col-lg-3 col-xxl-2">
                     <div className="card border-0 text-center">
                        <item.icon />
                        <div className="card-body">
                           <p className="lead">{item.desc}</p>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </div>
   );
};

export default Skills;
